"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

var TooltipDropdownMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TooltipDropdownMenu, _React$Component);

  function TooltipDropdownMenu() {
    (0, _classCallCheck2.default)(this, TooltipDropdownMenu);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TooltipDropdownMenu).apply(this, arguments));
  }

  (0, _createClass2.default)(TooltipDropdownMenu, [{
    key: "render",
    value: function render() {
      var className = "uig-tooltip-dropdown-menu ".concat(this.props.anchorRight ? 'anchor-right' : '');
      return _react.default.createElement("div", {
        className: className
      }, this.props.children);
    }
  }]);
  return TooltipDropdownMenu;
}(_react.default.Component);

exports.default = TooltipDropdownMenu;
TooltipDropdownMenu.propTypes = {
  children: _propTypes.default.element.isRequired,
  anchorRight: _propTypes.default.bool
};
TooltipDropdownMenu.defaultProps = {
  anchorRight: false
};